export default __webpack_public_path__ + "static/media/stealie.091d4612.png";